// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/compressed-air',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('service-management');
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/compressed-air',
  });

  return (
    <Card>
      <CardHeader
        title={t('services.compressedAir.title')}
        action={
          <ServiceActivationSwitch
            managedAccountId={accountId}
            servicePath="compressed-air"
            ariaLabel={t('services.compressedAir.title')}
          />
        }
        slotProps={{
          title: { variant: 'h6', fontWeight: 600 }
        }}
      />
      <Divider />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {t('services.compressedAir.description')}
        </Typography>
      </CardContent>
    </Card>
  );
}

